import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Source from './icon-lead-closed-goal.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Source {...validProps} />;
}
SvgComponent.iconName = 'goalLeadClosed';

export const GoalLeadClosedIcon = svgIconWrapper(SvgComponent);
